module.exports = __webpack_public_path__ + "static/media/comment-svgrepo-com (2).031c5ed0.svg";